import T from 'prop-types';
import React from 'react';
import text from '../../text';
import Img from '../img/Img';
import { useSelector } from 'react-redux';
var CartEmpty = function(param) {
    var hasAddOns = param.hasAddOns;
    var undefinedAddress = useSelector(function(state) {
        return state.jobsReducer.undefinedAddress;
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: "cart-empty pb-0"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "content"
    }, /*#__PURE__*/ React.createElement("h4", null, text('cartIsEmpty')), /*#__PURE__*/ React.createElement(Img, {
        img: hasAddOns && !undefinedAddress ? 'cart-empty-illustration' : 'cart-empty-illustration-no-addons',
        alt: "cart empty",
        className: "illustration"
    }), hasAddOns && !undefinedAddress ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("p", {
        style: {
            fontSize: 14
        },
        className: "wide"
    }, text('cartIsEmptyDescription1')), /*#__PURE__*/ React.createElement("p", {
        style: {
            fontSize: 14
        },
        className: "mb-2 wide"
    }, text('cartIsEmptyDescription2'))) : /*#__PURE__*/ React.createElement("p", {
        style: {
            fontSize: 14
        }
    }, text('cartIsEmptyNoAddOnsDescription'))));
};
CartEmpty.propTypes = {
    hasAddOns: T.bool.isRequired
};
export default CartEmpty;
